import { ZERO_HASH } from '../hash/hash';
export class CircomVerifierProof {
    constructor(_root = ZERO_HASH, _siblings = [], _oldKey = ZERO_HASH, _oldValue = ZERO_HASH, _isOld0 = false, _key = ZERO_HASH, _value = ZERO_HASH, _fnc = 0) {
        this.root = _root;
        this.siblings = _siblings;
        this.oldKey = _oldKey;
        this.oldValue = _oldValue;
        this.isOld0 = _isOld0;
        this.key = _key;
        this.value = _value;
        this.fnc = _fnc;
    }
}
export class CircomProcessorProof {
    constructor(_oldRoot = ZERO_HASH, _newRoot = ZERO_HASH, _siblings = [], _oldKey = ZERO_HASH, _oldValue = ZERO_HASH, _newKey = ZERO_HASH, _newValue = ZERO_HASH, _isOld0 = false, _fnc = 0) {
        this.oldRoot = _oldRoot;
        this.newRoot = _newRoot;
        this.siblings = _siblings;
        this.oldKey = _oldKey;
        this.oldValue = _oldValue;
        this.newKey = _newKey;
        this.newValue = _newValue;
        this.isOld0 = _isOld0;
        this.fnc = _fnc;
    }
}
//# sourceMappingURL=circom.js.map